// import './App.css';
import Todo from './component/Todo';
// import Test from './component/Test';

function App() {
  return (
    <div>
      <Todo/>
      {/* <Test/> */}
    </div>
  );
}

export default App;
